export default __webpack_public_path__ + "media/images/mailer/wordmark-cbf6986a52f00df59c9895deebb53981.png";